import React from "react";
import { BadgeCheck, Wrench } from "lucide-react";

type EngineBrandProps = {
  name: string;
  image: string;
  isAuthorizedDealer: boolean;
  isAuthorizedService: boolean;
};

const EngineBrandCard: React.FC<EngineBrandProps> = ({
  name,
  image,
  isAuthorizedDealer,
  isAuthorizedService,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center text-center hover:shadow-xl transition-transform hover:scale-105">
      <img src={image} alt={name} className="w-28 h-28 object-contain mb-4" />
      <h3 className="text-xl font-semibold mb-2">{name}</h3>
      <div className="flex flex-col gap-2 text-sm text-gray-600">
        {isAuthorizedDealer && (
          <span className="flex items-center gap-1 text-green-600">
            <BadgeCheck size={16} /> Yetkili Satıcı
          </span>
        )}
        {isAuthorizedService && (
            <span className="flex items-center gap-1 text-blue-600">
                <Wrench size={16} /> Yetkili Servis
            </span>
        )}
      </div>
    </div>
  );
};

export default EngineBrandCard;
